import React, { useEffect, useState } from "react";

//CSS
import "./tagIcon.css";

//Functions and hooks
import { GetTagData } from "../../BackendAccess/TagHooks";
import { useNotification } from "../../Contexts/NotificationContext";
import { useErrorHandler } from "../../hooks/errorHandler";

export default function TagIcon({
  tagID,
  selectable = true,
  selected = false,
  onSelected,
  bExpand = false,
  tagList = [],
}) {
  const [selectedColor, setSelectedColor] = useState();
  const [selectedName, setSelectedName] = useState();
  const [selectedState, setSelectedState] = useState(selected);
  const [error, setError] = useState(null);

  const { showNotification } = useNotification();

  useErrorHandler(error, showNotification);

  useEffect(() => {
    GetTagColor();
  }, [tagID, tagList]);
  useEffect(() => {
    setSelectedState(selected);
  }, [selected]);

  const handleClick = () => {
    if (selectable) {
      const newSelectedState = !selectedState;
      onSelected(newSelectedState, tagID);
    }
  };

  const GetTagColor = async () => {
    let data = tagList.find((tag) => parseInt(tag.TagID) === parseInt(tagID));
    console.log("Tag icon data", data, tagList);
    if (data === undefined) {
      const [tagData, tagError] = await GetTagData(tagID);
      if (tagError) {
        setError(tagError);
        return;
      }
      data = tagData;
    }
    if (data !== undefined) {
      setSelectedColor(data.Color);
      setSelectedName(data.Name);
    } else {
      setSelectedColor("hsl(0, 0%, 39%)");
      setSelectedName("/");
    }
  };

  const classNameContainer =
    "tag-icon" +
    (selectedState ? " selected" : "") +
    (bExpand ? " expand" : "") +
    (selectable ? " selectable" : "");

  return (
    <div onClick={handleClick} className={classNameContainer}>
      <div
        className={selectedState ? "tag-icon-color selected" : "tag-icon-color"}
      >
        <p
          className="tag-icon-color-circle"
          style={{ backgroundColor: selectedColor }}
        ></p>
        <p className="tag-icon-name">{selectedName}</p>
      </div>
    </div>
  );
}
